import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=65ac252e&scoped=true&"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=65ac252e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac252e",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions})
